var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm--map__geofence"},[_c('vrm-mapbox',{attrs:{"location":_vm.initialCoordinates},on:{"load":_vm.onMapboxLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }